import * as ActionTypes from '../constants/action_types'
import { DefaultState } from './DefaultState'
import * as ReducerUtils from './utils'

export const DefaultTopicMediaPlanState = {
    ...DefaultState
}

export const topicMediaPlan = ReducerUtils.makeSingleObjectReducer({
    defaultState: DefaultTopicMediaPlanState,
    actionRequest: ActionTypes.REQUEST_TOPIC_MEDIA_PLAN,
    actionReceive: ActionTypes.RECEIVE_TOPIC_MEDIA_PLAN,
    actionFailure: ActionTypes.REQUEST_TOPIC_MEDIA_PLAN_FAILURE,
    actionInvalidate: ActionTypes.INVALIDATE_TOPIC_MEDIA_PLAN
})